import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { SITE_ASSETS } from "../mock";

export default function StorySection() {
  const { story } = useSettings();
  const bgRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      const sec = sectionRef.current;
      const bg = bgRef.current;
      if (!sec || !bg) return;
      const rect = sec.getBoundingClientRect();
      const center = rect.top + rect.height / 2 - window.innerHeight / 2;
      bg.style.transform = `translate3d(0, ${center * -0.18}px, 0) scale(1.15)`;
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section ref={sectionRef} className="relative h-[110vh] overflow-hidden bg-[#1F1B17]">
      <div ref={bgRef} className="absolute inset-0 will-change-transform">
        <img src={SITE_ASSETS.hero.aerial} alt="Tamra aerial" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1F1B17]/85 via-[#1F1B17]/55 to-[#1F1B17]/30"></div>
      </div>
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 w-full">
          <div className="lg:col-span-7 text-[#F5EFE6]">
            <div className="text-[11px] tracking-[0.5em] text-[#B8893C] uppercase mb-6">Our Philosophy</div>
            <h2 className="font-display text-4xl md:text-6xl tracking-[0.06em] leading-[1.05] headline-spaced">{story.heading}</h2>
            <div className="mt-10 max-w-2xl text-[#E8DCC4] leading-relaxed text-lg whitespace-pre-line">
              {story.body}
            </div>
            <Link to="/about" className="btn-gold mt-10">Read Our Story</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
